import React from 'react';
const sides = {
    FROM:"from",
    TO:"to"
}

const otherSide = {
    [sides.FROM]:sides.TO,
    [sides.TO]:sides.FROM
}


class RangeFilter extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            [sides.FROM]:props[sides.FROM],
            [sides.TO]:props[sides.TO],
            visibleInput: true,
        }

        this.sideChange = this.sideChange.bind(this)
        this.updateValue = this.updateValue.bind(this)
        this.clearSide = this.clearSide.bind(this)
        this.updateView = this.updateView.bind(this)
        this.checkKey = this.checkKey.bind(this)
    }

    componentDidUpdate(prevProps) {
        // if props changed - update state.
        if ( prevProps[sides.FROM] !== this.props[sides.FROM] || prevProps[sides.TO] !== this.props[sides.TO] ) {
            this.setState({
                    [sides.FROM]: this.props[sides.FROM],
                    [sides.TO]: this.props[sides.TO]
                })
        }
    }

    clearSide(e) {
        let side = e.target.getAttribute("data-side")
        this.setState({[side]:""})
    }

    updateView(e) {
        let value = e.target.value
        let side = e.target.getAttribute("data-side")

        if ( value.length > 5 ) {
            value = value.substring(0,5)
        }

        if ( value.includes(".") && value.indexOf(".") + 3 < value.length ) {
            value = value.substring(0,value.indexOf(".")+3)
        }

        if ( isNaN(value) ) {
            value = ""
        }

        this.setState({[side]:value})
    }

    sideChange(e) {
        let value = parseFloat(e.target.value)
        let side = e.target.getAttribute("data-side")

        // get value of other side.
        let otherValue = this.props[otherSide[side]]

        // limit to 2 decimal numbers
        value = parseFloat(value.toFixed(2))

        if ( isNaN(value) ) {
            value = this.props[side]
        }
        // value validations.
        if ( value > this.props.maxValue ) {
            value = this.props.maxValue
        }
        if ( value < this.props.minValue ) {
            value = this.props.minValue
        }

        // so that from is higher than to - than don't allow that. make the values equal.
        if ( (side === sides.FROM && value > otherValue) ||
            (side === sides.TO && value < otherValue) ) {
            otherValue = value
        }

        this.setState({[side]:value,[otherSide[side]]:otherValue, visibleInput: false},() => {
            this.updateValue({
                [sides.FROM]: side === sides.FROM ? value : otherValue,
                [sides.TO]: side === sides.TO ? value : otherValue
            })
        })

        // this is need cause we have issue with the view and with state. If we type 01 in view will be 01 and in the state will be 1 and the same for .1
        setTimeout(() => this.setState({ visibleInput: true }), 0); // I know it isn`t best solution 
    }

    updateValue(newValue) {
        this.props.setFilters(this.props.name, newValue)
    }

    // In mobile ios chrome - the input number still allows non number chars. we need to programmatically take care of it.
    checkKey(e) {
        let side = e.target.getAttribute("data-side")
        if ( !e.key.match(/[\.0-9]/) || e.key == "." && this.state[side].indexOf(".") > -1 ) {
            e.preventDefault()
        }
    }

    render_filterSide(side,label) {
        return <div className={"range-filter-side range-filter-"+side}>
            <fieldset>
                <legend>{label}</legend>
                <div className={"range-filter-side-inner"}>
                    {this.state.visibleInput && (<input data-side={side}
                                                type={"number"}
                                                step={this.props.step}
                                                name={this.props.name+"-"+side}
                                                onKeyPress={this.checkKey}
                                                onBlur={this.sideChange}
                                                onChange={this.updateView}
                                                onFocus={this.clearSide}
                                                min={this.props.minValue}
                                                max={this.props.maxValue}
                                                value={this.state[side]}
                    />)}
                    <div className={"range-filter-side-text"}>
                        <span style={{opacity:0}}>{this.state[side]} </span>
                        {" " + this.props.label.toLowerCase()}
                    </div>
                </div>
            </fieldset>
        </div>
    }

    render() {
        return <div className={"filter range-filter"}>
            {this.render_filterSide(sides.FROM,this.props.fromLabel)}
            <div className={"range-filter-separator"}>&ndash;</div>
            {this.render_filterSide(sides.TO,this.props.toLabel)}
        </div>
    }
}
export default RangeFilter;